module.exports = __webpack_public_path__ + "app/img/Accident_French.57a59025.jpg";